export class AppConfig {
  static baseUrl = '';
}
